// extracted by mini-css-extract-plugin
export default {"footer":"footer__1rhD3","lightMode":"lightMode__3JU4f","legal":"legal__1QyMY"};